import { createContext } from 'react';

type TUserContext = {
  user: Maybe<User>;
};

export const UserContext = createContext<TUserContext>(undefined!);
